import { AuthActionTypes, AuthActions } from '@app-stores/actions/auth.action';
import * as errorHandler from '@app-shared/utils/error-handler';

export interface State {
	error: string | null;
	message: string | null;
	pending: boolean;
	success: boolean;
}

export const initialState: State = {
	error: null,
	message: null,
	pending: false,
	success: false,
};

export function reducer(state = initialState, action: AuthActions): State {
  switch (action.type) {
	case AuthActionTypes.Register: {
		return {
			...state,
			error: null,
			message: null,
			pending: true,
			success: false,
		};
	}
	case AuthActionTypes.RegisterSuccess: {
		return {
			...state,
			error: null,
			message: 'The user has been registered successfully!',
			pending: false,
			success: true,
		};
	}

	case AuthActionTypes.RegisterFailure: {
		return {
			...state,
			error: errorHandler.getHttpError(action.payload),
			pending: false,
		};
	}

	default: {
		return state;
	}
  }
}

export const getError = (state: State) => state.error;
export const getMessage = (state: State) => state.message;
export const getPending = (state: State) => state.pending;
export const getSuccess = (state: State) => state.pending;
